module.exports = __webpack_public_path__ + "img/pchomeain.4f0a7577.svg";